import { render } from "./TravelLayout.vue?vue&type=template&id=dba27e3e&scoped=true"
import script from "./TravelLayout.vue?vue&type=script&lang=js"
export * from "./TravelLayout.vue?vue&type=script&lang=js"

import "./TravelLayout.vue?vue&type=style&index=0&id=dba27e3e&scoped=true&lang=css"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dba27e3e"]])

export default __exports__